import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { CommunicationMethodFormValues } from 'src/models/CommunicationMethod.model';
import CommunicationMethodForm from '../Layouts/CommunicationMethodForm';
import { useEditCommunicationMethodMutation  } from 'src/services/CommunicationMethodServices';
import { useGetCommunicationMethodQuery } from 'src/services/CommunicationMethodServices';
import { showToast } from 'src/utils/showToaster';

type Props = {
  onClose: () => void;
  communicationId:string ;
};

const EditCommunicationMethodWrapper = ({ onClose , communicationId }: Props) => { 
 
  const [editCommunication] = useEditCommunicationMethodMutation();
  
  const {
    data ,
    isLoading,
    isFetching
  } = useGetCommunicationMethodQuery({
    id: communicationId,
  });

  const [communicationMethod, setcommunicationMethod] = useState<any>([]); 

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setcommunicationMethod(data?.data);
    }
  }, [data?.data, isLoading, isFetching]);

  // Form Initial Values
  const initialValues: CommunicationMethodFormValues = {
    communication_method :communicationMethod?.communication_method ,
    communication_type :communicationMethod?.communication_type
  };

  // Validation Schema
  const validationSchema = object().shape({
    communication_method: string().required('Please enter communication method'),
    communication_type: string().required('Please enter communication type'),
  });

  // Handle Submit
  const handleSubmit = (
    values: CommunicationMethodFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CommunicationMethodFormValues>
  ) => {
    editCommunication({
      id: communicationId ,
      body : values 
    }).then((res: any) => {
      if (res?.error) {
        showToast('error', res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast('success', res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast('error', res?.data?.message);
        }
      }
      setSubmitting(false);
    })
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik 
      enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <CommunicationMethodForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditCommunicationMethodWrapper;